import {
  UploadedDocumentDocumentType,
  UploadedDocumentInfoDocumentType,
} from '@urbanx/agx.campaigns.client'
import { DocumentTypesMap } from '@urbanx/agx-ui-components'
import type {
  DocumentGroup,
  StaffContractDetailModel,
  UploadedDocument,
  UploadedDocumentInfo,
} from '@urbanx/agx.campaigns.client'

const exchangeTaskDocumentTypes = new Set<UploadedDocumentDocumentType>([
  UploadedDocumentDocumentType.SalesAdvice,
  UploadedDocumentDocumentType.ExchangeLetter,
  UploadedDocumentDocumentType.SignedContract,
  UploadedDocumentDocumentType.Miscellaneous,
])

const getDocumentKey = (document: UploadedDocument) =>
  [
    document.containerName,
    document.documentType,
    document.containerFilePath,
    document.documentId,
    document.fileName,
  ]
    .filter(Boolean)
    .join('/')

const toUploadedDocumentInfo = (
  document: UploadedDocument
): UploadedDocumentInfo => ({
  ...document,
  title: DocumentTypesMap[document.documentType as keyof typeof DocumentTypesMap],
  documentType:
    document.documentType as unknown as UploadedDocumentInfoDocumentType,
})

export const getExchangeTaskDocumentGroups = (
  contract?: StaffContractDetailModel
): DocumentGroup[] => {
  const seen = new Set<string>()
  const documents = [
    contract?.contractDocuments?.salesAdvice,
    contract?.contractDocuments?.exchangeLetter,
    ...(contract?.documents ?? []),
  ]
    .filter(
      (document): document is UploadedDocument =>
        !!document?.containerFilePath &&
        !!document.documentType &&
        exchangeTaskDocumentTypes.has(document.documentType)
    )
    .filter((document) => {
      const key = getDocumentKey(document)
      if (seen.has(key)) return false

      seen.add(key)
      return true
    })
    .map(toUploadedDocumentInfo)

  return documents.length > 0
    ? [
        {
          title: contract?.contractName ?? 'Contract Documents',
          documents,
        },
      ]
    : []
}
